/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CopyDocumentResponseData,
  CopyDocumentResponseDataFromJSON,
  CopyDocumentResponseDataFromJSONTyped,
  CopyDocumentResponseDataToJSON
} from './CopyDocumentResponseData'

/**
 *
 * @export
 * @interface GetDocumentResponse
 */
export interface GetDocumentResponse {
  /**
   *
   * @type {number}
   * @memberof GetDocumentResponse
   */
  status?: number
  /**
   *
   * @type {CopyDocumentResponseData}
   * @memberof GetDocumentResponse
   */
  data?: CopyDocumentResponseData
}

export function GetDocumentResponseFromJSON(json: any): GetDocumentResponse {
  return GetDocumentResponseFromJSONTyped(json, false)
}

export function GetDocumentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDocumentResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CopyDocumentResponseDataFromJSON(json['data'])
  }
}

export function GetDocumentResponseToJSON(value?: GetDocumentResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CopyDocumentResponseDataToJSON(value.data)
  }
}
